<template>
    <!-- 收货地址 -->
    <div class="address-section">
        <div class="section-title">
            <div class="title-container">
                <div class="line"></div>
                <span>收货地址</span>
            </div>
            <el-button type="text" class="add-address-btn" @click="openAddressDialog">+ 新增收货地址</el-button>
        </div>
        <div class="address-list">
            <div class="address-card" :class="{ 'active': localSelectedIndex == index }"
                v-for="(address, index) in addresses" :key="index" @click="selectAddress(address, index)">
                <img src="../../../assets/images/26.png" alt="" v-if="localSelectedIndex == index">
                <img src="../../../assets/images/27.png" alt="" v-else>
                <div class="address-header" v-if="address.label_name">
                    <div class="label-box">{{ address.label_name }}</div>
                    <div>
                        <span class="name">{{ address.real_name }}({{ address.sex == 1 ? '先生' : '女士' }})</span>
                        <span class="phone">{{ address.mobile }}</span>
                    </div>
                </div>
                <div class="address-content">
                    {{ address.province }}{{ address.city }}{{ address.district }}{{ address.detail }}
                </div>
                <div class="address-footer">
                    <el-button v-if="address.is_default == 1" type="primary" size="small" plain>
                        默认地址
                    </el-button>
                    <el-button v-else type="primary" size="small" plain @click.native="setAddressFn(address, index)">
                        设置为默认地址
                    </el-button>
                    <el-button type="text" size="small" @click.native="editAddressFn(address)">编辑</el-button>
                    <el-button type="text" size="small"
                        @click.native="dialogVisibleDelete = true; chooseAddress = address">删除</el-button>
                </div>
            </div>
        </div>

        <el-dialog title="新增收货地址" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
            <div>
                <NewAddress ref="newAddress" @addressAdded="handleAddressAdded" @close="handleClose"
                    :address="chooseAddress" :isEdit="isEdit"></NewAddress>
            </div>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span> -->
        </el-dialog>

        <el-dialog title="提示" :visible.sync="dialogVisibleDelete" width="30%" :before-close="handleClose">
            <span>是否删除该地址？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleDelete = false">取 消</el-button>
                <el-button type="primary" @click="deleteAddressFn(chooseAddress)">确 定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
import NewAddress from './NewAddress.vue'
export default {
    name: 'ShippingAddress',
    components: {
        NewAddress
    },
    props: {
        addresses: {
            type: Array,
            default: () => []
        },
        selectedAddressIndex: {
            type: [Number, String],
            default: -1
        }
    },
    data() {
        return {
            // 声明本地属性，以 prop 为初始值
            localSelectedIndex: this.selectedAddressIndex,
            dialogVisible: false,
            dialogVisibleDelete: false,
            chooseAddress: {},
            isEdit: false
        }
    },
    watch: {
        selectedAddressIndex: {
            handler(newVal) {
                this.localSelectedIndex = newVal;
            },
            immediate: true
        }
    },
    methods: {
        // 选择地址
        selectAddress(address, index) {
            this.localSelectedIndex = index;
            this.$emit('selectAddress', address.aid);
        },
        openAddressDialog() {
            // this.resetForm(); // 新增时重置表单
            this.dialogVisible = true;
        },
        // 处理地址添加成功事件
        handleAddressAdded() {
            // 发射事件通知父组件
            this.$emit('addressListUpdated');
        },

        // 设置默认地址
        setAddressFn(address, index) {
            // this.$refs.addressDialog.setAddressFn(addressId);
            console.log('设置默认地址', address);
            this.$dapi.setAddressFn({
                address_id: address.aid
            }).then(res => {
                this.$message.success('设置默认地址成功');
                this.$emit('setAddressFn', address);
                this.localSelectedIndex = 0
            }).catch(err => {
                this.$message.error(err);
            })
        },

        handleClose() {
            this.dialogVisible = false;
        },

        // 删除地址
        deleteAddressFn(address, index) {
            this.$dapi.deleteAddressFn({
                address_id: address.aid
            }).then(res => {
                this.$message.success('删除地址成功');
                this.$emit('addressListUpdated');
                this.dialogVisibleDelete = false
                this.localSelectedIndex = 0
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 编辑地址
        editAddressFn(address) {
            console.log('打开弹窗');
            this.chooseAddress = JSON.parse(JSON.stringify(address));
            this.dialogVisible = true
            this.isEdit = true
        }
    }
}
</script>



<style scoped>
.title-container {
    display: flex;
    align-items: center;
}

.line {
    width: 4px;
    height: 18px;
    background: #286CED;
    border-radius: 0px 0px 0px 0px;
    margin-right: 12px;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
}

.section-title i {
    margin-right: 8px;
    color: #409eff;
}

/* 收货地址样式 */
.address-section {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.active {
    border: 1px solid #409eff !important;
}

.add-address-btn {
    margin-left: auto;
    color: #FF9735;
}

.address-list {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}

.address-card {
    width: 300px;
    padding: 15px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
    position: relative;
    text-align: left;
}

.address-card img {
    width: 24px;
    height: 24px;
    position: absolute;
    bottom: 0;
    right: 0;
}

.address-card:hover {
    border-color: #409eff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.address-header {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}

.label-box {
    /* width: 30px;
    height: 22px; */
    padding: 3px 8px;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #FF9735;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #FF9735;
    margin-right: 10px;
}



.name {
    font-weight: bold;
    margin-right: 10px;
}

.phone {
    color: #666;
}

.address-content {
    margin-bottom: 15px;
    color: #666;
    line-height: 1.5;
}

.address-footer {
    display: flex;
    align-items: center;
    gap: 10px;
}
</style>
